import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-success-stories-load-more',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (hasMore) {
      <div class="cg-ss-load-more">
        <button type="button" class="cg-ss-load-more__btn" [disabled]="loading" (click)="loadMore.emit()">
          {{ loading ? 'Loading…' : 'Load More Stories' }}
        </button>
      </div>
    }
  `,
})
export class SuccessStoriesLoadMoreComponent {
  @Input() hasMore = false;
  @Input() loading = false;
  @Output() loadMore = new EventEmitter<void>();
}
